<template>
    <div class="Switchlang">
        <v-menu
            left
            bottom
        >
            <template v-slot:activator="{ on, attrs }">
            <v-btn
                icon
                v-bind="attrs"
                v-on="on"
            >
                {{$i18n.locale}}
                <v-img
                :lazy-src="require('@/assets/'+$i18n.locale+'.png')"
                max-height="57"
                max-width="25"
                :src="require('@/assets/'+$i18n.locale+'.png')"
                ></v-img>
            </v-btn>
            </template>
            <v-list>
            <v-list-item
                v-for="langs in lang"
                :key="langs.title"
                @click="setLocale(langs.action)"
            >
                <v-list-item-title>{{ langs.title }}</v-list-item-title>
            </v-list-item>
            </v-list>
        </v-menu>
    </div>
    
</template>
<script>
export default {
    name: 'Switchlang',
    data: () => ({
        lang: [
            {title:'Bm', action: 'bm'}, 
            {title:'En', action: 'en'}
        ],
    }),
    methods: {
        setLocale(locale) {
            if(locale !== this.$i18n.locale){
                this.$i18n.locale = locale
                this.$router.push({
                    params: { lang: locale }
                })
                this.$router.go()
            }
        }
    },
    setup() {
        
    },
}
</script>